@use "ui/styles/sizes";

.stepBody {
  min-height: sizes.$s19;
}
